import {
  Component,
  DestroyRef,
  effect,
  inject,
  linkedSignal,
  OnInit,
  viewChild,
  ViewContainerRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { provideIcons } from '@ng-icons/core';
import { lucideCircleX } from '@ng-icons/lucide';
import { ChipComponent } from '@shared/components/chip/chip.component';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmToasterImports } from '@spartan-ng/helm/sonner';
import { filter } from 'rxjs';

import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { SidepanelContentComponent } from './shared/components/sidepanel/sidepanel-content.component';
import { SidepanelDescriptionComponent } from './shared/components/sidepanel/sidepanel-description.component';
import { SidepanelFooterComponent } from './shared/components/sidepanel/sidepanel-footer.component';
import { SidepanelHeaderComponent } from './shared/components/sidepanel/sidepanel-header.component';
import { SidepanelComponent } from './shared/components/sidepanel/sidepanel.component';
import { SidepanelService } from './shared/components/sidepanel/sidepanel.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    MainLayoutComponent,
    HlmToasterImports,
    SidepanelComponent,
    SidepanelContentComponent,
    SidepanelDescriptionComponent,
    SidepanelFooterComponent,
    SidepanelHeaderComponent,
    HlmButtonImports,
    ChipComponent,
  ],
  providers: [provideIcons({ lucideCircleX })],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  readonly #sidepanelService = inject(SidepanelService);
  readonly #router = inject(Router);
  readonly #destroyRef = inject(DestroyRef);

  readonly sidepanelRef = viewChild('sidepanelContainer', { read: ViewContainerRef });
  readonly footerSidepanelRef = viewChild('footerSidepanelContainer', { read: ViewContainerRef });

  readonly sidepanelTitle = linkedSignal(this.#sidepanelService.title);
  readonly sidepanelChips = linkedSignal(this.#sidepanelService.chips);
  readonly sidepanelDescription = linkedSignal(this.#sidepanelService.description);

  constructor() {
    effect(() => {
      this.#sidepanelService.setViewContainerRef(this.sidepanelRef()!);
      this.#sidepanelService.setFooterViewContainerRef(this.footerSidepanelRef()!);
    });
  }

  ngOnInit(): void {
    this.#router.events
      .pipe(
        filter((x) => x instanceof NavigationEnd),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(() => this.#sidepanelService.close());
  }
}
